/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Grupa tematyczna zdarzenia, uzywana do filtrowania w UI
 */

export const ActivityCategoryDto = {
    Process: 'PROCESS',
    Offer: 'OFFER',
    OfferContent: 'OFFER_CONTENT',
    Money: 'MONEY',
    Email: 'EMAIL',
    Note: 'NOTE',
} as const;

export type ActivityCategoryDto = typeof ActivityCategoryDto[keyof typeof ActivityCategoryDto];



